/**
 * 获取菜单
 */
export function getMenuList() {
    return [
        { text: "首页", path: 'index' },
        { text: "题库设置", path: 'question-bank-index' },
        { text: "试卷设置", path: 'paper-index' },
        { text: "考试设置", path: 'exam-index' },
        { text: "上岗证管理", path: 'work-license-index' },
        { text: "职业技能等级管理", path: 'occupation-index' },
        { text: "系统设置", path: 'system-index' },
    ]
}

/**
 * 根据父菜单,获取对应的子菜单数据
 * @param {*} fatherMenu 
 */
export function getSubMenuListByFatherMenu(fatherMenu) {
    let data = []
    switch (fatherMenu) {
        case 'question-bank-index':
            // 题库
            data = [
                { text: "题库管理", path: "list" },
                { text: "科目管理", path: "subject" }
            ]
            break;
        case 'paper-index':
            // 试卷
            data = [
                { text: "试卷管理", path: "list" },
            ]
            break
        case 'work-license-index':
            // 上岗证
            data = [
                { text: "上岗证考核", path: "list" },
                { text: "上岗证管理", path: "manage" },
                { text: "上岗证设置", path: "setting" },
            ]
            break
        case 'occupation-index':
            // 职业技能等级
            data = [
                { text: "职业技能等级考核", path: "list" },
                { text: "职业技能等级设置", path: "setting" },
            ]
            break
        case 'exam-index':
            // 考试
            data = [
                { text: "考试管理", path: "list" },
                { text: "阅卷管理", path: "read" },
            ]
            break;
        case "system-index":
            // 系统设置
            data = [
                { text: "通讯录设置", path: "person" },
                { text: "部门设置", path: "department" },
                { text: "标签设置", path: "tag" },
                { text: "专业设置", path: "profession" },
            ]
            break

        default:
            break;
    }
    return data
}

/**
 * 返回有权限的列表
 * @param {*} array 所有列表
 * @param {*} authorityList 所有权限列表
 */
export function returnAllButton(array, authorityList, key) {
    let data = []
    array.forEach(element => {
        if (authorityList.includes(element[key])) {
            data.push(element)
        }
    });
    return data
}